import axios from '@/libs/api.request'
import config from '@/config'
import { v4 as uuidv4 } from 'uuid'
const token = `${uuidv4()}-ops-cmdb_${uuidv4()}`
const cmdbBaseUrl = config.baseCMDBUrl + '/cmdb/api/v1/'
export const assetUploadFileUrl = cmdbBaseUrl + 'asset_import/'
export const assetFlowUploadFileUrl = cmdbBaseUrl + 'asset_flow_import/'

// cmdb列表显示列 ↓2
export const getServerTableCol = () => {
  return axios.request({
    url: cmdbBaseUrl + 'server_table_col/',
    method: 'get'
  })
}

export const postServerTableCol = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'server_table_col/',
    data: data,
    method: 'post'
  })
}

// 审批调用的方法
export const approvalFlow = (data, id, type) => {
  return axios.request({
    url: cmdbBaseUrl + type + '/approval/' + id + '/',
    data: data,
    method: 'put'
  })
}

export const getApprovalProcess = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'approval_process/',
    params: params,
    method: 'get'
  })
}

export const getOpsTypeReleaseSteps = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_ops_type_release_steps/',
    data: data,
    method: 'post'
  })
}

export const getOperateReleaseFlow = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'operate_release_flow/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const createOperateReleaseFlow = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'operate_release_flow/',
    data: data,
    method: 'post'
  })
}

export const detailOperateReleaseFlow = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'operate_release_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteOperateReleaseFlow = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'operate_release_flow/' + id + '/',
    method: 'delete'
  })
}

// 资产转移
export const getTransferFlow = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'transfer_flow/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const createTransferFlow = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'transfer_flow/',
    data: data,
    method: 'post'
  })
}

export const detailTransferFlow = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'transfer_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteTransferFlow = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'transfer_flow/' + id + '/',
    method: 'delete'
  })
}

export const getOpsFLowTypeRoles = (opsFLowTypeId, params) => {
  return axios.request({
    url: cmdbBaseUrl + 'ops_flow_roles/' + opsFLowTypeId + '/get/',
    params: params,
    method: 'get'
  })
}

export const modifyOpsFLowTypeRoles = (data, opsFLowTypeId) => {
  return axios.request({
    url: cmdbBaseUrl + 'ops_flow_roles/' + opsFLowTypeId + '/modify/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

// 取需要审批类型列表（带分页）
export const getOpsFLowTypes = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'ops_flow_type/',
    params: params,
    method: 'get'
  })
}

// 取需要审批类型所有类型列表
export const getAllOpsFLowTypes = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'all_ops_flow_type/',
    params: params,
    method: 'get'
  })
}

// 固定资产
export const getOpsCenterAssets = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'assets/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllAssets = () => {
  return axios.request({
    url: cmdbBaseUrl + 'all_assets_list/',
    method: 'get'
  })
}

export const detailOpsCenterAssets = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'assets/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterAssets = (data, id) => {
  let url = cmdbBaseUrl + 'assets/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterAssets = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'assets/' + id + '/',
    method: 'delete'
  })
}

// 供应商
export const getOpsCenterSupplier = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'supplier/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllSupplier = () => {
  return axios.request({
    url: cmdbBaseUrl + 'all_supplier_list/',
    method: 'get'
  })
}

export const detailOpsCenterSupplier = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'supplier/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterSupplier = (data, id) => {
  let url = cmdbBaseUrl + 'supplier/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterSupplier = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'supplier/' + id + '/',
    method: 'delete'
  })
}

// 资产类型
export const getOpsCenterAssetType = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_type/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllAssetType = () => {
  return axios.request({
    url: cmdbBaseUrl + 'all_asset_type_list/',
    method: 'get'
  })
}

export const detailOpsCenterAssetType = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_type/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterAssetType = (data, id) => {
  let url = cmdbBaseUrl + 'asset_type/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterAssetType = (id) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_type/' + id + '/',
    method: 'delete'
  })
}

// 资产修改记录
export const getOpsCenterAssetLogs = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_logs/',
    params: params,
    method: 'get'
  })
}

// 资产流动记录
export const getOpsCenterAssetFlow = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_flow/',
    params: params,
    method: 'get'
  })
}

// 借出资产
export const LendOpsCenterAsset = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'lend_asset/',
    data: data,
    method: 'post'
  })
}

// 归还资产
export const ReturnOpsCenterAsset = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'return_asset/',
    data: data,
    method: 'post'
  })
}

// 维修资产
export const MaintainOpsCenterAsset = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'maintain_asset/',
    data: data,
    method: 'post'
  })
}

// 报废资产
export const ScrapOpsCenterAsset = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'scrap_asset/',
    data: data,
    method: 'post'
  })
}

// 资产统计
export const getOpsCenterAssetsCount = () => {
  return axios.request({
    url: cmdbBaseUrl + 'assets_count/',
    method: 'get'
  })
}

export const getContentTypeId = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_content_type_id',
    params: params,
    method: 'get'
  })
}

export const getRevisionLogs = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'revision_logs_list/',
    params: params,
    method: 'get'
  })
}

// 盘点
export const changeInventory = (data) => {
  let url = cmdbBaseUrl + 'inventory_count/'
  let method = 'post'
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const getInventory = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'inventory_count/',
    params: params,
    method: 'get'
  })
}

export const overInventory = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'over_inventory/',
    data: data,
    method: 'post'
  })
}

export const cancelInventory = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'cancel_inventory/',
    data: data,
    method: 'post'
  })
}

export const getInventoryCommodities = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'inventory_commodities/',
    params: params,
    method: 'get'
  })
}

export const exportInventoryReport = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'export_inventory_report/',
    params: params,
    method: 'get'
  })
}

// 导出所有资产
export const exportAssetAll = () => {
  return axios.request({
    url: cmdbBaseUrl + 'report_assets_all/',
    method: 'get'
  })
}

// 导出当前资产
export const exportAssetCurrent = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'report_assets_current/',
    params: params,
    method: 'get'
  })
}

// 获取资产定制字段
export const getAssetFields = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_asset_field/',
    params: params,
    method: 'get'
  })
}

// 自定义导出资产
export const exportAssetCustom = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'custom_export/',
    params: params,
    method: 'get'
  })
}

// 获取人员模糊查找数据
export const getPeopleLst = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_wechat_people_list/',
    params: params,
    method: 'get'
  })
}

// 获取初始组织结构数据
export const getWxOrg = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_wechat_department_list/',
    params: params,
    method: 'get'
  })
}

// 获取初始组织结构数据（返回邮箱）
export const getWxOrgEmail = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_wechat_department_list_email/',
    params: params,
    method: 'get'
  })
}

// 按资产类别（笔记本、电脑等）统计数量以及占比
export const getAssetsType = () => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_show_type/',
    method: 'get'
  })
}

// 按资产状态（借出、入库等）统计数量（可自定义时间节点）以及占比
export const getAssetsStatus = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_show_status/',
    params: params,
    method: 'get'
  })
}

// 按资产状态（借出、入库等）和 日期 分组统计数量（可自定义时间节点）以及占比
export const getAssetsStatusTime = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_show_status_time/',
    params: params,
    method: 'get'
  })
}

// 通过asset_id获取资产信息
export const getAssetData = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_asset_data/',
    data: data,
    method: 'post'
  })
}

// 新增asset变更流程
export const addAssetWorkflow = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_workflow/',
    data: data,
    method: 'post'
  })
}

// 获取asset变更流程
export const getAssetWorkflow = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'asset_workflow/',
    params: params,
    method: 'get'
  })
}

// 获取asset变更流程列表
export const getAssetWorkflowAll = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'assets_workflow_all/',
    params: params,
    method: 'get'
  })
}

// 通过asset_id获取资产信息
export const getAssetDataByWorkflow = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_asset_data_by_workflow/',
    data: data,
    method: 'post'
  })
}

// 通过Name获取资产信息
export const getAssetDataByName = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'get_asset_data_by_workflow/',
    params: params,
    method: 'get'
  })
}

// 软件价格列表
export const getSoftwareAssetsPrice = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_price/',
    params: params,
    method: 'get'
  })
}

// 软件价格列表
export const addSoftwareAssetsPrice = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_price/',
    data: data,
    method: 'post'
  })
}

// 软件价格列表
export const updateSoftwareAssetsPrice = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_price/${data.id}/`,
    data: data,
    method: 'put'
  })
}

// 软件价格列表
export const deleteSoftwareAssetsPrice = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_price/${data.id}/`,
    data: data,
    method: 'delete'
  })
}

// 软件资产相关日志
export const getSoftwareAssetsLog = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_log/',
    params: params,
    method: 'get'
  })
}

// 软件资产相关日志
export const addSoftwareAssetsLog = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_log/',
    data: data,
    method: 'post'
  })
}

// 授权软件列表
export const getSoftwareAssetsAuthorize = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_authorize/',
    params: params,
    method: 'get'
  })
}

// 授权软件列表
export const addSoftwareAssetsAuthorize = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_authorize/',
    data: data,
    method: 'post'
  })
}

// 授权软件列表
export const updateSoftwareAssetsAuthorize = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_authorize/${data.id}/`,
    data: data,
    method: 'put'
  })
}

// 授权软件列表
export const deleteSoftwareAssetsAuthorize = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_authorize/${data.id}/`,
    data: data,
    method: 'delete'
  })
}

// 授权软件列表
export const getSoftwareAssetsDistribute = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_authorize_distribute/',
    params: params,
    method: 'get'
  })
}

// 授权软件列表
export const addSoftwareAssetsDistribute = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_authorize_distribute/',
    data: data,
    method: 'post'
  })
}

// 授权软件列表
export const updateSoftwareAssetsDistribute = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_authorize_distribute/${data.id}/`,
    data: data,
    method: 'put'
  })
}

// 授权软件列表
export const deleteSoftwareAssetsDistribute = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_authorize_distribute/${data.id}/`,
    data: data,
    method: 'delete'
  })
}

// 授权软件列表
export const getSoftwareAssetsWorkflow = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_workflow/',
    params: params,
    method: 'get'
  })
}

// 授权软件列表
export const addSoftwareAssetsWorkflow = (data) => {
  return axios.request({
    url: cmdbBaseUrl + 'software_assets_workflow/',
    data: data,
    method: 'post'
  })
}

// 授权软件列表
export const updateSoftwareAssetsWorkflow = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_workflow/${data.id}/`,
    data: data,
    method: 'put'
  })
}

// 授权软件列表
export const deleteSoftwareAssetsWorkflow = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `software_assets_workflow/${data.id}/`,
    data: data,
    method: 'delete'
  })
}

// 盘点信息
export const getAssetInventoryInformation = (params) => {
  params['token'] = token
  return axios.request({
    url: cmdbBaseUrl + 'asset/inventory_information/',
    params: params,
    method: 'get'
  })
}

// 新增盘点信息
export const addAssetInventoryInformation = (data) => {
  data['token'] = token
  return axios.request({
    url: cmdbBaseUrl + 'asset/inventory_information/',
    data: data,
    method: 'post'
  })
}

// 盘点信息列表
export const getInventoryInformation = (params) => {
  return axios.request({
    url: cmdbBaseUrl + 'inventory_information/',
    params: params,
    method: 'get'
  })
}

// 更新盘点信息列表
export const updateInventoryInformation = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `inventory_information/${data.id}/`,
    data: data,
    method: 'put'
  })
}

// 删除盘点信息列表
export const deleteInventoryInformation = (data) => {
  return axios.request({
    url: cmdbBaseUrl + `inventory_information/${data.id}/`,
    data: data,
    method: 'delete'
  })
}
